export default __webpack_public_path__ + "static/media/no-image-available.4eaa4fb9.svg";